import * as yup from 'yup';
// import ITInquery from '../../interfaces/inquiry/inquiry';

export const contactInitialValues = {
	mission: '',
	name: '',
	ssn: '',
	address: '',
	email: '',
	phone: '',
    trackingnumber: '',
	residence: '',
	zip: '',
	comments: '',
};

export const contactSchema = yup.object().shape({
	mission: yup.string().required('required'),
	name: yup.string(),
	ssn: yup.string(),
	address: yup.string(),
	email: yup
		.string()
		.email('emailNotValid')
		.required('required'),
	phone: yup.string(),
	trackingnumber: yup.string(),
	residence: yup.string(),
	zip: yup.string(),
	comments: yup.string(),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
});
